import { CrxInputText, CrxSwitch } from '@cortex/cortex-core'
import { useSectorDrawerContent } from '../hooks/useSectorDrawerContent'
import { SectorTransferSection } from './SectorTransferSection'
import { FieldErrors, UseFormWatch, UseFormSetValue } from 'react-hook-form'
import { SectorFormData } from '../schemas/sectorSchema'
import { Sector } from 'types/sector'

interface SectorDrawerContentProps {
  watch: UseFormWatch<SectorFormData>
  setValue: UseFormSetValue<SectorFormData>
  errors: FieldErrors<SectorFormData>
  handleStatusChange: (newStatus: string) => void
  isCheckingNotifications: boolean
  hasNotifications: boolean | null
  availableSectors: Sector[]
  createNewSector: boolean
}

export const SectorDrawerContent = ({ 
  watch, 
  setValue, 
  errors, 
  handleStatusChange,
  isCheckingNotifications,
  hasNotifications,
  availableSectors,
  createNewSector
}: SectorDrawerContentProps) => {
  const { nameValue, statusValue, handleNameChange, handleStatusChange: handleStatusToggle } = useSectorDrawerContent({
    watch,
    setValue,
    handleStatusChange
  })

  const showTransferSection = !createNewSector && statusValue === 'false' && hasNotifications === true

  return (
    <div className='flex flex-col items-start gap-8'>
      <span className='text-typograpy-1 font-medium font-Roboto'>Dados do setor</span>
      <CrxInputText
        supportText={errors.name?.message || ''}
        id="input-text-nome-setor"
        label="Nome do setor"
        placeholder="Digite aqui..."
        required
        maskType='default'
        error={!!errors.name?.message}
        inputProps={{
          value: nameValue ?? "",
          onChange: (e) => handleNameChange(e.target.value),
        }}
      />
      <CrxSwitch
        ariaLabel="Switch"
        required
        selected={statusValue === "true"}
        inputProps={{
          name: 'radio',
          onChange: handleStatusToggle
        }}
      >
        {statusValue === "true" ? 'Ativo' : 'Inativo'}
      </CrxSwitch>
      
      {showTransferSection && (
        <SectorTransferSection
          isLoading={isCheckingNotifications}
          hasNotifications={hasNotifications}
          availableSectors={availableSectors}
          watch={watch}
          setValue={setValue}
          errors={errors}
        />
      )}
    </div>
  )
}